/**
 * useTheme — hook globalnego przełączania motywu (dark/light).
 * Stan zapisywany w localStorage. Atrybut `data-theme` ustawiany na <html>.
 */

import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'mr_jerry_theme';

const getInitialTheme = () => {
  if (typeof window === 'undefined') return 'dark';
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    // localStorage zablokowany (np. tryb prywatny) — używamy domyślnego motywu
    if (process.env.NODE_ENV !== 'production') console.warn('[useTheme] localStorage read blocked');
  }
  return 'dark';
};

const applyTheme = (theme) => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
};

export const useTheme = () => {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); }
    catch { if (process.env.NODE_ENV !== 'production') console.warn('[useTheme] localStorage write blocked'); }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setThemeState((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  const setTheme = useCallback((t) => {
    if (t === 'dark' || t === 'light') setThemeState(t);
  }, []);

  return { theme, toggleTheme, setTheme };
};

// Apply theme synchronously on module load to avoid flash
applyTheme(getInitialTheme());
